import { memo } from "react";

// eslint-disable-next-line @bigbinary/neeto/use-webpack-alias
import { Button, Typography } from "@bigbinary/neetoui";
import { withT } from "neetocommons/react-utils";

import { FULL_SHORTCUTS_LINK_PROP_NAME } from "./constants";
import HotKey from "./HotKey";

const HotKeyList = withT(({ t, hotkeys }) =>
  Object.keys(hotkeys).map(categoryName => {
    const categoryValues = hotkeys[categoryName];
    const fullShortcutsLink = categoryValues[FULL_SHORTCUTS_LINK_PROP_NAME];

    return (
      <div className="mt-4 px-4" key={categoryName}>
        <Typography style="h6" textTransform="uppercase" weight="bold">
          {categoryName}
        </Typography>
        {Object.entries(categoryValues).map(
          ([, { sequence, description }]) =>
            sequence && <HotKey {...{ description, sequence }} key={sequence} />
        )}
        {fullShortcutsLink && (
          <Button
            className="mb-3"
            href={fullShortcutsLink}
            style="link"
            target="_blank"
            label={t(
              "neetoMolecules.keyboardShortcuts.viewFullListOfShortcuts"
            )}
          />
        )}
      </div>
    );
  })
);

export default memo(HotKeyList);
